const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/$workoutId.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/workouts/$workoutId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { WorkoutNotFoundError } from '@/features/workouts/domain/errors';
import { getWorkoutQuery } from '@/features/workouts/lib/get-workout.query';
import { WorkoutsSkeleton } from '@/features/workouts/ui/workouts-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/workouts/$workoutId')({
  beforeLoad: ({
    context,
    params
  }) => {
    const validated = context.deps.validators.workoutIdValidator.validate(params.workoutId);
    if (!validated.ok) {
      throw redirect({
        to: '/tracking/workouts/history'
      });
    }
    return {
      workoutId: validated.data
    };
  },
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        workoutController: context.deps.controllers.workoutController
      }
    };
    try {
      await context.queryClient.ensureQueryData(getWorkoutQuery(deps, context.workoutId));
    } catch (error) {
      if (error instanceof WorkoutNotFoundError) {
        throw redirect({
          to: '/tracking/workouts/history'
        });
      }
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: WorkoutsSkeleton
});